import IconDiamond from '@/components/assets/icon_diamond.svg'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
export default function PremiumTag({ className }: { className?: string }) {
  const t = useTranslations()
  return (
    <Badge
      className={cn(
        'bg-vive-surface-normal/40 hover:bg-vive-surface-normal/40 max-w-fit cursor-default gap-1.5 rounded-[5px] px-2 py-1 backdrop-blur-md',
        className,
      )}
    >
      <IconDiamond className="size-[12px] fill-[#FF82FB]" />
      <span className="bg-gradient-title-3 bg-clip-text text-transparent">
        {t('premium-badge.label')}
      </span>
    </Badge>
  )
}
